import { __assign } from "tslib";
import { CoherencePanelSize, getResponsivePanelWidth } from '@coherence-design-system/utilities';
export var getStyles = function (props) {
    var theme = props.theme, isFooterInBody = props.isFooterInBody, _a = props.panelSize, panelSize = _a === void 0 ? CoherencePanelSize.small : _a;
    return {
        subComponentStyles: {
            panelStyles: {
                main: {
                    selectors: __assign({}, getResponsivePanelWidth(panelSize, isFooterInBody))
                },
                overlay: {
                    backgroundColor: theme.palette.blackTranslucent40
                }
            }
        }
    };
};
//# sourceMappingURL=CoherencePanel.styles.js.map